
$.fn.completeSection = function(sectionNumber, UserID){
  let checked = false;
  if($(this).is(':checked')){
    checked = true;
  }
  const postdata = {CatNumber: sectionNumber, UserID: UserID, Checked: checked};


  $.ajax({
    url : window.location.pathname+"saveCompleteSection",
    type: "POST",
    data : postdata,
    success: function(data, textStatus, jqXHR)
    {
      $.toasternote('Success', 'The stage has been updated')
    },
    error: function (jqXHR, textStatus, errorThrown)
    {
      $.toasternote('Error', "Couldn't save, please try again in a few minutes")
    }
  });
}
$(function() {
  $('.ctc img').click(function() {
    $('#copytoclipboard').focus().select();
    document.execCommand('copy');
    $.toasternote('Success', 'Copied to Clipboard')
  });
});
